const toQueryParams = (object: {}): string =>
  Object.keys(object)
    .map(key => `${key}=${encodeURIComponent(object[key] || "")}`)
    .join("&");

export default toQueryParams;
